import { logInfoMessage } from '../sentry';
const PREFIX = 'ptc-dir-ui.';
const memoryLocalStorage = {
  data: {},
  setItem: (key, value) => {
    memoryLocalStorage.data[key] = value;
  },
  getItem: key => {
    return memoryLocalStorage.data[key];
  },
  removeItem: key => {
    delete memoryLocalStorage.data[key];
  }
};
const localStorage = window.localStorage || memoryLocalStorage;

// A facade for browser localstorage.
export default {
  isQuotaExceeded() {
    const key = `${PREFIX}:${Date.now()}`;
    try {
      localStorage.setItem(key, 'test');
    } catch (e) {
      return true;
    } finally {
      localStorage.removeItem(key);
    }
    return false;
  },
  setItem(key, value) {
    try {
      localStorage.setItem(PREFIX + key, value);
      return true;
    } catch (error) {
      // maybe we can use cookie as alternative storage
      logInfoMessage('Cannot read into localstorage', {
        error
      });
    }
    return false;
  },
  getItem(key) {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch (error) {
      logInfoMessage('Cannot read into localstorage', {
        error
      });
    }
    return null;
  },
  getItemSafely(key, defaultValue, fallback) {
    try {
      const storedValue = localStorage.getItem(PREFIX + key);
      if (storedValue) {
        return storedValue;
      }
      if (this.setItem(key, defaultValue)) {
        return defaultValue;
      }
    } catch (error) {
      logInfoMessage('Cannot read into localstorage', {
        error
      });
    }
    return fallback;
  }
};